import React, { useEffect, useState } from "react";
import "./Stats.css";

const statsData = [
  { id: 1, value: 12, suffix: "+", label: "Years In Business" },
  { id: 2, value: 895, suffix: "+", label: "Happy Clients" },
  { id: 3, value: 900, suffix: "+", label: "Projects Completed" },
  { id: 4, value: 42, suffix: "+", label: "Trained Staff" },
];

const Stats = () => {
  const [counts, setCounts] = useState([0, 0, 0, 0]);

  useEffect(() => {
    statsData.forEach((stat, index) => {
      let start = 0;
      const end = stat.value;
      const duration = 2000;
      const step = Math.ceil(end / (duration / 30));

      const counter = setInterval(() => {
        start += step;
        if (start >= end) {
          start = end;
          clearInterval(counter);
        }
        setCounts(prev => {
          const newCounts = [...prev];
          newCounts[index] = start;
          return newCounts;
        });
      }, 30);
    });
  }, []);

  return (
    <div className="stats-wrapper">
      {statsData.map((stat, i) => (
        <div key={stat.id} className="stat-item">
          <h2 className="stat-number">
            {counts[i]}
            {stat.suffix}
          </h2>
          <p className="stat-label">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default Stats;
